const getUserData = () => {
  const LS_key_user = "user";

  try {
    if (localStorage.getItem(LS_key_user)) {
      return JSON.parse(localStorage.getItem(LS_key_user));
    }
    return {
      role: "",
      modules: "",
    };
  } catch (e) {
    return {
      role: "",
      modules: "",
    };
  }
};

const getToken = () => {
  return JSON.parse(localStorage.getItem("user")).token;
};

const HTTP_GET = async (url) => {
  let headerObj = {
    "content-type": "application/json",
    Authorization: `Bearer ${getToken()}`,
  };
  const clientId = getUserData()?.clientId;

  if (clientId) {
    headerObj = {
      ...headerObj,
      clientId: clientId,
    };
  }

  const data = await fetch(url, {
    method: "GET",
    headers: new Headers(headerObj),
  });

  return await data.json();
};

const HTTP_GET_DOWNLOAD_FILE = async (url) => {
  let headerObj = {
    Authorization: `Bearer ${getToken()}`,
  };
  const clientId = getUserData()?.clientId;

  if (clientId) {
    headerObj = {
      ...headerObj,
      clientId: clientId,
    };
  }

  const data = await fetch(url, {
    method: "GET",
    headers: new Headers(headerObj),
  });

  return await data;
};

const HTTP_POST = async (url, body) => {
  try {
    let headerObj = {
      "content-type": "application/json",
      Authorization: `Bearer ${getToken()}`,
    };
    const clientId = getUserData()?.clientId;

    if (clientId) {
      headerObj = {
        ...headerObj,
        clientId: clientId,
      };
    }

    const data = await fetch(url, {
      method: "POST",
      headers: new Headers(headerObj),
      body: JSON.stringify(body),
    }).catch((e) => {
      return {
        statusCodeValue: 500,
      };
    });
    return await data.json();
  } catch (e) {
    return {
      statusCodeValue: 500,
    };
  }
};

const HTTP_POST_AUTH = async (url, body) => {
  const clientId = getUserData()?.clientId;

  const data = await fetch(url, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      clientId: clientId,
    },
    body: JSON.stringify(body),
  });

  return await data.json();
};

const HTTP_POST_MULTIPART = async (url, body) => {
  let headerObj = {
    "content-type": "application/json",
    Authorization: `Bearer ${getToken()}`,
  };
  const clientId = getUserData()?.clientId;

  if (clientId) {
    headerObj = {
      ...headerObj,
      clientId: clientId,
    };
  }

  const data = await fetch(url, {
    method: "POST",
    headers: headerObj,
    body,
  });

  return await data.json();
};

module.exports = {
  HTTP_GET,
  HTTP_POST,
  HTTP_POST_AUTH,
  HTTP_POST_MULTIPART,
  HTTP_GET_DOWNLOAD_FILE,
  getToken,
};
